module.exports = __webpack_public_path__ + "img/zizhi1.754ce9a2.png";